export default {
    unidadesAdm: [],
    unidadeAdm: {}
}